export default __webpack_public_path__ + "static/media/la3.2.5365ae9e.png";